import React, { useState } from 'react';
import { API_BASE_URL } from '../config';

function Login({ onLogin }) {
    const [step, setStep] = useState(1); // 1: email, 2: otp, 3: credentials
    const [emailId, setEmailId] = useState('');
    const [userId, setUserId] = useState(null);
    const [otp, setOtp] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState(null);
    const [encOtp, setEncOtp] = useState(null);
   // console.log('API_BASE_URL:', API_BASE_URL);
    // Step 1: Verify Email
    const handleVerifyEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch(`${API_BASE_URL}/userApi.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'verifyEmail', emailId })
            });
            const data = await res.json();
            if (data.success) {
                setUserId(data.userId);
                setEncOtp(data.encotp);
                setStep(2);
            } else {
                setError(data.message || 'Email verification failed');
            }
        } catch (err) {
            setError('Server error');
        }
        setLoading(false);
    };

    // Step 2: Verify OTP
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch(`${API_BASE_URL}/userApi.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'verifyOtp', emailId, otp, encOtp })
            });
            const data = await res.json();
            if (data.success) {
                // Fetch user data for username/password
                const res2 = await fetch(`${API_BASE_URL}/userApi.php`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ action: 'getUser', userId: data.userId })
                });
                const userData = await res2.json();
                if (userData.success) {
                    setUserData(userData.user);
                    setUsername(userData.user.userName);
                    setStep(3);
                } else {
                    setError('User data not found');
                }
            } else {
                setError(data.message || 'OTP verification failed');
            }
        } catch (err) {
            setError('Server error');
        }
        setLoading(false);
    };

    // Step 3: Username/Password
    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        // Compare username/password with userData
        if (!userData) {
            setError('User data missing');
            setLoading(false);
            return;
        }
        if (username !== userData.userName) {
            setError('Username does not match');
            setLoading(false);
            return;
        }
        if (password !== userData.decPassword && password !== userData.pw) {
            setError('Password does not match');
            setLoading(false);
            return;
        }
        onLogin();
        setLoading(false);
    };

    return (
        <div className="login-page">
            <div className="login-form">
                <h1>Welcome Back</h1>
                <p style={{textAlign: 'center', color: '#1f2937', marginBottom: '2rem'}}>Sign in to access the admin panel</p>
                
                {step === 1 && (
                    <form onSubmit={handleVerifyEmail}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <input
                                id="emailId"
                                type="email"
                                className="form-control"
                                placeholder="your@email.com"
                                value={emailId}
                                onChange={e => setEmailId(e.target.value)}
                                required
                                autoFocus
                                aria-label="Email"
                            />
                        </div>
                        <button className="btn btn-primary w-100" type="submit" disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Verifying...
                                </>
                            ) : (
                                'Verify Email'
                            )}
                        </button>
                        {error && <div className="alert alert-danger py-2 mt-3 mb-0">{error}</div>}
                    </form>
                )}

                {step === 2 && (
                    <form onSubmit={handleVerifyOtp}>
                        <div className="form-group">
                            <label>Enter OTP</label>
                            <input
                                id="otp"
                                type="text"
                                className="form-control"
                                placeholder="000000"
                                value={otp}
                                onChange={e => setOtp(e.target.value)}
                                required
                                autoFocus
                                maxLength={6}
                                aria-label="OTP"
                                style={{textAlign: 'center', fontSize: '1.5rem', letterSpacing: '8px'}}
                            />
                            <small style={{color: '#6b7280', display: 'block', marginTop: '0.5rem'}}>
                                Check your email for the OTP code
                            </small>
                        </div>
                        <button className="btn btn-primary w-100" type="submit" disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Verifying OTP...
                                </>
                            ) : (
                                'Verify OTP'
                            )}
                        </button>
                        {error && <div className="alert alert-danger py-2 mt-3 mb-0">{error}</div>}
                    </form>
                )}

                {step === 3 && (
                    <form onSubmit={handleLogin}>
                        <div className="form-group">
                            <label>Username</label>
                            <input
                                id="username"
                                type="text"
                                className="form-control"
                                placeholder="Enter username"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                required
                                autoFocus
                                aria-label="Username"
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input
                                id="password"
                                type="password"
                                className="form-control"
                                placeholder="Enter password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                                aria-label="Password"
                            />
                        </div>
                        <button className="btn btn-primary w-100 py-2" type="submit" disabled={loading} style={{fontSize: '1rem', fontWeight: 600}}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Logging in...
                                </>
                            ) : (
                                'Login to Dashboard'
                            )}
                        </button>
                        {error && <div className="alert alert-danger py-2 mt-3 mb-0">{error}</div>}
                    </form>
                )}
            </div>
        </div>
    );
}

export default Login;
